
<template>
          <v-row align="center" no-gutters>
            <v-col cols="12" align="center" >
                <v-row v-for="gruppo in menu.sottogruppi" :key="gruppo.idsottogruppo">
                  <raggruppamento-piatti 
                  :gruppo="gruppo" 
                  :gruppoprincipale="gruppo"  
                  :nospiti="menu.nospiti" 
                  :carrello ="menu.carrello" 
                  :flat_menu = "flat_menu" 
                  :show_images = "show_images" 
                  :show_prices= "show_prices"
                  :enable_orders="enable_orders" 
                  @ordinapiatto="ordinapiatto($event)"
                  @rimuovipiatto="rimuovipiatto($event)"></raggruppamento-piatti>
                </v-row>
            </v-col>
          </v-row>
</template>
<script>

export default {     
    components: {
    },
    props:['menu','show_images','show_prices','flat_menu','enable_orders'],
    data: () => ({        
    }),
    methods:{
      ordinapiatto(piatto){
        //console.log("ordinapiatto menu",piatto)
        this.$emit('ordinapiatto', piatto)
      },
      rimuovipiatto(piatto){
        //console.log("rimuovipiatto menu",piatto)
        this.$emit('rimuovipiatto', piatto)
      }
    }
    
}
</script>
